<dc-navbar-default [darkLinks]="false"></dc-navbar-default>
<main class="position-relative overflow-hidden">
  <dc-terms-terms></dc-terms-terms>
</main>
